module.exports = __webpack_public_path__ + "img/headRight5.0ec801eb.png";